import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  subscriptionPlanWrapper: {
    marginTop: theme.spacing(1),
  },
  paymentElementWrapper: {
    padding: '8px',
    display: 'flex',
    justifyContent: 'center',
  },
}));
